import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import { Routes, Route } from "react-router";
import Tickets from "./pages/Tickets/Tickets";
import TourPackages from "./pages/Tour-packages/TourPackages";
import HajjUmrahPackages from "./pages/Hajj- umrah-packages/HajjUmrahPackages";
import PassportServices from "./pages/Passport-Services/PassportServices";
import VisaServices from "./pages/Visa-services/VisaServices";
import Enquiries from "./pages/Enquiries/Enquiries";

function App() {
  return (
    <>
      <Routes>
        {/* Home */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/tickets" element={<Tickets/>}/>
        <Route path="/tour-packages/" element={<TourPackages/>}/>
        <Route path="/hajj-umrah-packages" element={<HajjUmrahPackages/>}/>
        <Route path="/passport-services" element={<PassportServices/>}/>
        <Route path="/visa-services" element={<VisaServices/>}/>
        <Route path="/enquiries" element={<Enquiries/>}/>

        {/* Auth */}
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/forgotpassword" element={<ForgotPassword />} />
      </Routes>
    </>
    
  );
}

export default App;
